import { useContext } from 'react';

import { ConfigContext } from 'Context/config';

import { isOfficeHours } from 'Utilities/isOfficeHours/isOfficeHours';

import { useAgentAvailability } from './useAgentAvailability';

export const useLiveChatAvailable = (): boolean => {
  useAgentAvailability();

  const { configState } = useContext(ConfigContext);

  return configState.agentAvailability?.liveChatAvailable ?? isOfficeHours();
};
